import { render, staticRenderFns } from "./gatewayRouting.vue?vue&type=template&id=1fcf51a4&scoped=true"
import script from "./gatewayRouting.vue?vue&type=script&lang=js"
export * from "./gatewayRouting.vue?vue&type=script&lang=js"
import style0 from "./gatewayRouting.vue?vue&type=style&index=0&id=1fcf51a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcf51a4",
  null
  
)

export default component.exports